import { FormStore } from '@roc/feature-app-core';
import {
  createCurrencyField,
} from '../../../components/temp/componentBuiderTemp';
import { observer } from 'mobx-react';


export const HighestPropertyAsIsValue = observer(({ store }: { store: FormStore }) => {
  return (
    <>
      {createCurrencyField({
        label: "Highest Property As Is Value in the Portfolio",
        fieldName: 'maximumAsIsValue',
        testId: 'maximumAsIsValue',
        store,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true
      })}
    </>
  );
});